import { RollbackOutlined } from '@ant-design/icons';
import { Box, Button, Card, useHistory } from 'shared';
import { TokenForceRefresher } from 'Auth';
import React from 'react';
import { useSentryUser } from 'Users/hooks/SentryUserProvider';
import { getCompanyLogo } from 'App/utils/logoUtils';
import { CompanyLogoImage } from 'App/components/CompanyLogoImage';

export interface PageNotFoundProps {}

export const PageNotFound: React.FC<PageNotFoundProps> = ({}) => {
  const { goBack } = useHistory();

  const { user } = useSentryUser();

  const logoImage = getCompanyLogo(user || null);

  return (
    <TokenForceRefresher>
      <div className="sentry-gradient-content">
        <Card
          title={
            <CompanyLogoImage
              src={logoImage}
              alt="Company Logo"
              fallbackSrc="/sentry-logo.png"
            />
          }
          headStyle={{
            backgroundColor: 'var(--torq-experimental-primary-color)',
          }}
        >
          <Box padding={{ left: 'sm', bottom: 'lg', right: 'sm' }}>
            <span style={{ fontSize: 15 }}>
              The page you are looking for could not be found!
            </span>
          </Box>
          <div>
            <Button
              type="link"
              icon={<RollbackOutlined />}
              onClick={goBack}
              size="large"
            >
              Go Back
            </Button>
          </div>
        </Card>
      </div>
    </TokenForceRefresher>
  );
};
